// @ts-nocheck
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PinInput, RingProgress } from '@mantine/core';
import { Anchor, Button, Center, Group, Stack, Text, Title } from '@/components/ui';
import { IconArrowLeft, IconClock } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function OtpGradient() {
  const [otp, setOtp] = useState('');
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [timeLeft]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('OTP submitted:', otp);
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const progress = (timeLeft / 120) * 100;

  return (
    <AuthLayoutWrapper
      variant="gradient"
      glassEffect
      gradientFrom="#7c3aed"
      gradientTo="#c026d3"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/demo/auth-pages/otp"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header with timer */}
        <Center>
          <Stack align="center" gap="md">
            <RingProgress
              size={100}
              thickness={6}
              sections={[{ value: progress, color: 'violet' }]}
              label={
                <Center>
                  <Stack align="center" gap={0}>
                    <IconClock size={20} color="var(--mantine-color-violet-6)" />
                    <Text size="sm" fw={600}>{formatTime(timeLeft)}</Text>
                  </Stack>
                </Center>
              }
            />
            <Title order={2} ta="center">Enter OTP</Title>
            <Text c="dimmed" size="sm" ta="center" maw={280}>
              Enter the code sent to j***@email.com
            </Text>
          </Stack>
        </Center>

        {/* OTP Input */}
        <form onSubmit={handleSubmit}>
          <Stack gap="lg">
            <Center>
              <PinInput
                length={6}
                size="lg"
                value={otp}
                onChange={setOtp}
                type="number"
                oneTimeCode
                disabled={timeLeft === 0}
              />
            </Center>

            <Button
              type="submit"
              fullWidth
              size="md"
              variant="gradient"
              gradient={{ from: '#7c3aed', to: '#c026d3' }}
              disabled={otp.length !== 6 || timeLeft === 0}
            >
              Verify code
            </Button>
          </Stack>
        </form>

        {/* Resend */}
        <Center>
          {timeLeft === 0 ? (
            <Button variant="subtle" onClick={() => setTimeLeft(120)}>
              Resend code
            </Button>
          ) : (
            <Text size="sm" c="dimmed">
              Resend available in {formatTime(timeLeft)}
            </Text>
          )}
        </Center>

        {/* Back to Login */}
        <Center>
          <Anchor component={Link} to="/demo/auth-pages/login/gradient" size="sm">
            <IconArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
            Cancel verification
          </Anchor>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
